import {
  FaPhoneVolume,
} from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaMapLocationDot } from "react-icons/fa6";
import uae from "../assets/icons/uae.png";
import uk from "../assets/icons/uk.png";

import DegitalMarketing from "../assets/images/degital marketing.jpg";
import WebsiteDevelopment from "../assets/images/mixed-programers-team-working-group-project-multiple-screens-showing-running-code-it-startup-office-coder-pointing-pencil-computer-screen-with-software-compiling-code.jpg";
import ItSolutions from "../assets/images/standard-quality-control-collage-concept.jpg";
import ProductionServices from "../assets/images/portrait-fitness-influencer.jpg";


export const servicesData = [
  {
    title: "service_one_title",
    description: "service_one_subtitle",
    buttonText: "more",
    image: DegitalMarketing,
    features: [
      {
        title: "feature_2_title",
        description: "feature_1212_description",
      },
      {
        title: "feature_3_title",
        description: "feature_1213_description",
      },
      {
        title: "feature_4_title",
        description: "feature_1214_description",
      },
      {
        title: "feature_1_title",
        description: "feature_1_description",
      },

      {
        title: "feature_5_title",
        description: "feature_1215_description",
      },
      {
        title: "feature_6_title",
        description: "feature_1216_description",
      },
    ],
  },
  {
    title: "service_two_title",
    description: "service_two_subtitle",
    buttonText: "more",
    image: ItSolutions,
    features: [
      {
        title: "feature_19_title",
        description: "feature_19_description",
      },
      {
        title: "feature_20_title",
        description: "feature_20_description",
      },
      {
        title: "feature_21_title",
        description: "feature_21_description",
      },
    ],
  },
  {
    title: "service_three_title",
    description: "service_three_subtitle",
    buttonText: "more",

    image: WebsiteDevelopment,
    features: [
      {
        title: "feature_7_title",
        description: "feature_7_description",
      },
      {
        title: "feature_8_title",
        description: "feature_8_description",
      },
      {
        title: "feature_9_title",
        description: "feature_9_description",
      },
      {
        title: "feature_10_title",
        description: "feature_10_description",
      },
    ],
  },
  {
    title: "service_four_title",
    description: "service_four_subtitle",
    buttonText: "more",
    image: ProductionServices,
    features: [
      {
        title: "feature_13_title",
        description: "feature_13_description",
      },
      {
        title: "feature_14_title",
        description: "feature_14_description",
        isActive: true,
      },
      {
        title: "feature_15_title",
        description: "feature_15_description",
      },
      {
        title: "feature_16_title",
        description: "feature_16_description",
      },
    ],
  },
];

export const navItems = [
  {
    id: 1,
    name: "home",
    link: "/",
    sectionName: "/",
  },
  {
    id: 2,
    name: "portfolio",
    link: "/About",
    sectionName: "About",
  },
  {
    id: 3,
    name: "services",
    link: "/Services",
    sectionName: "Services",
  },
  {
    id: 4,
    name: "software_development",
    link: "/software-development",
    sectionName: "",
  },
  {
    id: 5,
    name: "our_clients",
    link: "/Clients",
    sectionName: "Clients",
  },
  {
    id: 6,
    name: "contact",
    link: "/Contact",
    sectionName: "Contact",
  },
];

export const Languages = [
  { id: 1, name: "English", logo: uk, lang: "en" },
  { id: 2, name: "Arabic", logo: uae, lang: "ar" },
];

export const appointmentInfo = [
  {
    title: "phone",
    description: "07504494818, 07844494818",
    icon: <FaPhoneVolume className="text-white" />,
    animation: { "data-aos": "fade-right", "data-aos-duration": "1000" },
  },
  {
    title: "email",
    description: "info@drsheban.com",
    icon: <MdEmail className="text-white" />,
    animation: { "data-aos": "fade-left", "data-aos-duration": "1000" },
    link: "mailto:info@drsheban.com",
  },
  {
    title: "address",
    description: "address_subtitle",
    icon: <FaMapLocationDot className="text-white " />,
    animation: { "data-aos": "fade-right", "data-aos-duration": "1000" },
    link: "https://www.google.com/maps/dir//Dr+Sheban+farhad+near+aya+supermarket+Erbil,+Erbil+Governorate+44001/@36.2017803,44.0326096,16z/data=!4m8!4m7!1m0!1m5!1m1!1s0x40072351fcefae9d:0xeb1be8815bad3f5f!2m2!1d44.0326096!2d36.2017803?entry=ttu&g_ep=EgoyMDI0MDkxOC4xIKXMDSoASAFQAw%3D%3D",
  },
];

export const WorksData = [
  {
    title: "service_one_title",
    features: [
      {
        title: "feature_3_title",
        description: "1",
        bannerImage: "https://cdn.jsdelivr.net/gh/Aruba-Creative/arubawebsite-images@main/images/thumbnails/photography.jpg",
        isActive: true,
        works: [
          {
            description: "feature_1_description",
            clientName: "client name",
            date: "27/10/2024",
            bannerImage: "https://cdn.jsdelivr.net/gh/Aruba-Creative/arubawebsite-images@main/images/thumbnails/photography.jpg",
           
            videos: [
        
            ]
          },
        ],
      },


      {
        title: "feature_2_title",
        description: "2",
        bannerImage: "https://cdn.jsdelivr.net/gh/Aruba-Creative/arubawebsite-images@main/images/thumbnails/motion-graphics.jpg",
        isActive: true,
        works: [
          {
            description: "feature_1_description",
            clientName: "client name",
            date: "27/10/2024",
            bannerImage: "https://cdn.jsdelivr.net/gh/Aruba-Creative/arubawebsite-images@main/images/thumbnails/motion-graphics.jpg",
            images: [

            ],
            videos: [
              {
                videoId: "s6njZMa7QNg?si=zfpuvkGmyqPDcC_T"
              },
              {
                videoId: "Q4WYlvRtMnE?si=ZtvzWMFQyA75bNhM"
              },
              {
                videoId: "jPa9wKxWA5g?si=kHcS_ROXlgUds5JP"
              },
              {
                videoId: "MNcxUQhd1Lo?si=gY1wOhwEExg5li3_"
              },
              {
                videoId: "APHMY1CJauk?si=rH3JrI_bUjZa07QC"
              }
            ]
          },
        ],
      },

      {
        title: "feature_18_title",
        description: "6",
        bannerImage: "https://cdn.jsdelivr.net/gh/Aruba-Creative/arubawebsite-images@main/images/thumbnails/socialmedia.jpg",
        isActive: true,
        works: [
          {
            description: "feature_1_description",
            clientName: "client name",
            date: "27/10/2024",
            bannerImage: "https://cdn.jsdelivr.net/gh/Aruba-Creative/arubawebsite-images@main/images/thumbnails/socialmedia.jpg",
            
            videos: [
        
            ]
                    },
        ],
      },
    ],
  },
  {
    title: "service_four_title",
    features: [

      {
        title: "feature_14_title",
        description: "feature_1_description",
        isActive: true,
        bannerImage: "https://cdn.jsdelivr.net/gh/Aruba-Creative/arubawebsite-images@main/images/thumbnails/photography.jpg",
        works: [
          {
            description: "feature_1_description",
            clientName: "client name",
            date: "27/10/2024",
            bannerImage: "https://cdn.jsdelivr.net/gh/Aruba-Creative/arubawebsite-images@main/images/thumbnails/photography.jpg",
            
            videos: [
        
            ]
                    },
        ],
      },


      {
        title: "feature_13_title",
        description: "4",
        bannerImage: "https://cdn.jsdelivr.net/gh/Aruba-Creative/arubawebsite-images@main/images/thumbnails/production.jpg",
        isActive: true,
        works: [
          {
            description: "feature_1_description",
            clientName: "client name",
            date: "27/10/2024",
            bannerImage: "https://cdn.jsdelivr.net/gh/Aruba-Creative/arubawebsite-images@main/images/thumbnails/production.jpg",
            images: [

            ],
            videos: [
              {
                videoId: "6nLWUFR77ig?si=PWfIHBNgBcHaQBn5"
              },
              {
                videoId: "I_1cy_y0taM?si=FArytfr2q9PBNiUl"
              },
              {
                videoId: "mwmzUUD-GuY?si=oSqbHVBrd4VBTBxN"
              },

              {
                videoId: "Q7ukrzqIIFk?si=KRcdUZMYnwQHBvMO"
              },
              {
                videoId: "BRnJaZY4vJU?si=ybvlnnjUt75_oYSq"
              },
              {
                videoId: "Q4WYlvRtMnE?si=wAZK-fEnr7mKQ5Q3"
              },
              {
                videoId: "l9Mu9ObQv2U?si=bDtPZoX2UDp0Mfru"
              },
              {
                videoId: "6M2hkN33QPQ?si=imQbU_mPM8iUBG0s"
              }
            ]
          },
        ],
      },
    ],
  },
];